<app-page>
  <div class="dashboard">
    <app-page-title [title]="'DASHBOARD.OVERVIEW.TITLE' | translate">
      <div
        *ngIf="isUserInIddGroup || isSuperAdmin || isManager || isTrainer"
      >
        <div class="dashboard-toolbar">
          <div
            *ngIf="isSuperAdmin"
            cssClass="organisation-unit-filter"
          >
            <dx-drop-down-box
              [(value)]="selectedOrganisationUnitIds"
              valueExpr="id"
              displayExpr="name"
              [label]="'COMMON.FIELDS.LOCATIONS-DEPARTMENTS' | translate"
              [dataSource]="organisationUnits"
              labelMode="floating"
              stylingMode="outlined"
              [width]="300"
              [height]="38"
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  [searchEnabled]="true"
                  [dataSource]="organisationUnits"
                  dataStructure="plain"
                  keyExpr="id"
                  selectionMode="multiple"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="onOrganisationUnitsSelected($event)"
                ></dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>

          <div>
            <dx-tabs 
              keyExpr="key"
              [scrollByContent]="true"
              [selectedItemKeys]="[selectedPeriod]"
              [items]="periodPanelItems"
              (onSelectionChanged)="onPeriodDateSelectionChanged($event)"
              (onItemClick)="onPeriodTabClicked($event)"
              [disabled]="editMode"
              [scrollByContent]="true"
              [width]="isMobile ? '310px' : '400px'"
            >
              <div *dxTemplate="let item of 'item'">
                <ng-container *ngIf="item.key === DatePeriodModel.Custom; else customDateTemplate">
                  <i class="dx-icon dx-svg-icon" [innerHTML]="getCalendarIcon()"></i>
                </ng-container>
                <ng-template #customDateTemplate>
                  <span *ngIf="item.key !== DatePeriodModel.Custom" [ngClass]="{
                    'tab-selected': item.key === selectedPeriod
                    }" 
                  >
                    {{ item.text }}
                  </span>
                </ng-template>
              </div>
            </dx-tabs>
          </div>
        </div>

        <app-date-range-modal 
          *ngIf="isCustomDatePopupOpen"
          [(showModal)]="isCustomDatePopupOpen"
          [range]="customDateRange"
          (rangeChange)="onCustomDateRangeChanged($event)"
          [minDate]="minFilterDate"
          [maxDate]="maxFilterDate"  
        ></app-date-range-modal>
      </div>
    </app-page-title>

    <div *ngIf="isSuperAdmin">
      <ng-container *ngIf="!isDashboardStatisticsLoaded; else dashboardStatisticsTemplate">
        <app-component-loader [minHeight]="100" [diameter]="80"/>
      </ng-container>
      <ng-template #dashboardStatisticsTemplate>
        <app-dashboard-statistics-widget />
      </ng-template>
    </div>
   
    <div *ngIf="canViewLearningRecommendations">
      <div class="recommendation-panel">
        <app-learning-recommendations-widget 
          [isLoaded]="isLearningRecommendationsLoaded"
          (onReload)="loadLearningRecommendations()"
        />
      </div>
    </div>
    
    <ng-container *ngIf="!isPersonWidgetsLoaded; else personWidgetsTemplate">
      <app-component-loader />
    </ng-container>
    <ng-template #personWidgetsTemplate>
      <div class="dashboard-toolbar-actions">
        <ng-container *ngIf="!editMode; else editModeTemplate">
          <dx-button
            *ngIf="!editMode"
            [text]="'COMMON.EDIT' | translate"
            stylingMode="contained"
            type="default"
            class="edit-button"
            (onClick)="enableEditMode()"
          >
          </dx-button>
        </ng-container>
        <ng-template #editModeTemplate>
          <dx-button
            [text]="'COMMON.SAVE' | translate"
            stylingMode="contained"
            type="normal"
            (onClick)="save()"
          >
          </dx-button>
          <dx-button
            [text]="'COMMON.CANCEL' | translate"
            stylingMode="contained"
            type="danger"
            (onClick)="cancel()"
          >
          </dx-button>
          
          <dx-button
            [text]="'WIDGETS.FORM.ADD-WIDGET' | translate"
            type="default"
            (onClick)="toggleAddWidgetDrawer()"
          ></dx-button>
        </ng-template>
      </div>

      <div class="row dashboard-grid-container" *ngIf="hasVisiblePersonWidgets">
        <div
          [class.col-md-12]="!isAddWidgetDrawerOpen"
          [class.col-md-9]="isAddWidgetDrawerOpen"
        >
          <ng-container *ngIf="!editMode; else editWidgetsTemplate">
            <div class="row">
              <ng-container *ngFor="let widget of personWidgets; let i = index">
                <div
                  class="col-xs-12 col-sm-12 col-md-6"
                  *ngIf="getWidgetHasData(widget.key)"
                >
                  <div class="panel-wrapper">
                    <app-panel
                      class="dashboard-panel"
                      [title]="widget.title"
                    >
                      <ng-container
                        *ngIf="getWidgetLoadedStatus(widget.key); else loadingWidgetTemplate"
                      >
                        <div class="year-filter-wrapper">
                          <dx-select-box
                            *ngIf="widget.key === WIDGET_KEYS.TREND_TO_TARGET_IDD_DATA"
                            labelMode="floating"
                            stylingMode="outlined"
                            [label]="'COMMON.FIELDS.YEAR' | translate"
                            placeholder=""
                            displayExpr="name"
                            width="100px"
                            valueExpr="id"
                            [value]="qualificationStatusFilterYear"
                            [dataSource]="yearsDropdownDataSource"
                            (onValueChanged)="onQualificationStatusYearFilterChanged($event)"
                          >
                          </dx-select-box>
                        </div>

                        <ng-container
                          *ngComponentOutlet="widget.component"
                        ></ng-container>
                      </ng-container>

                      <ng-template #loadingWidgetTemplate>
                        <div class="loading-spinner">
                          <app-component-loader />
                        </div>
                      </ng-template>
                    </app-panel>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-template #editWidgetsTemplate>
            <dx-sortable
              [data]="widgetColumns"
              itemOrientation="horizontal"
              handle=".panel-header"
              [dropFeedbackMode]="'indicate'"
              class="sortable-columns"
            >
              <div
                class="col-xs-12 col-sm-12 col-md-6"
                *ngFor="let column of widgetColumns; let colIndex = index; trackBy: trackByWidgetId"
              >
                <dx-sortable
                  [data]="column"
                  itemOrientation="vertical"
                  [dropFeedbackMode]="'push'"
                  group="widgetsGroup"
                  (onDragStart)="onDashboardWidgetDragStart($event)"
                  (onReorder)="onDashboardWidgetsReorder($event, colIndex)"
                  (onAdd)="onWidgetsAddToDashboard($event, colIndex)"
                  class="sortable-widgets"
                >
                  <div class="sortable-panel-wrapper"
                    *ngFor="let widget of column; let widgetIndex = index"
                  >
                    <app-panel class="dashboard-panel" [title]="widget.title">
                      
                      <ng-container *ngIf="getWidgetLoadedStatus(widget.key); else loadingWidgetTemplate">
                        <ng-container *ngComponentOutlet="widget.component"></ng-container>
                        <div class="widget-remove-button-wrapper">
                            <dx-button
                              *ngIf="editMode"
                              [text]="'COMMON.REMOVE' | translate"
                              type="danger"
                              (onClick)="removeDashboardColumnWidget(colIndex, widgetIndex)"
                            >
                          </dx-button>
                        </div>
                      </ng-container>
                      <ng-template #loadingWidgetTemplate>
                        <div class="loading-spinner">
                          <app-component-loader />
                        </div>
                      </ng-template>
                    </app-panel>
                  </div>
                </dx-sortable>
              </div>
            </dx-sortable>
          </ng-template>
        </div>
        <div class="col-md-3" *ngIf="isAddWidgetDrawerOpen">
          <div class="add-widget-sidebar-content">
            <h3 class="drawer-title">{{ "WIDGETS.FORM.ADD-WIDGET" | translate}}</h3>

            <div *ngIf="widgetsGallery.length == 0" class="no-widgets-message">
              <span>{{ "WIDGETS.FORM.NO-WIDGETS-TO-DISPLAY" | translate}}</span>
            </div>

            <dx-sortable
              [data]="widgetsGallery"
              group="widgetsGroup"
              class="gallery-widgets-container"
              (onDragStart)="onGalleryWidgetDragStart($event)"
              (onAdd)="onAddWidgetToGallery($event)"
            >
              <div
                class="gallery-widget-item"
                *ngFor="let widget of widgetsGallery"
              >
                <dx-button
                  class="overlay-add-button"
                  icon="plus"
                  stylingMode="text"
                  type="success"
                  (onClick)="addWidget(widget.key)"
                ></dx-button>
                <div class="gallery-widget-component-wrapper">
                  <ng-container *ngComponentOutlet="widget.demoComponent"></ng-container>
                </div>

                <div class="widget-text">
                  <div class="widget-title">{{ widget.model!.name }}</div>
                  <div class="widget-description">{{ widget.model!.description }}</div>
                </div>
              </div>
            </dx-sortable>
          </div>
        </div>
      </div>
    </ng-template>

    <div *ngIf="canSeeEmployeeWidgets && isInitialDataLoaded">
      <div class="dashboard-card">
        <h2>{{ "DASHBOARD.CARD.TITLE" | translate }}</h2>
        <p>
          {{ "DASHBOARD.CARD.TEXT-1" | translate }}
        </p>
        <p>
          {{ "DASHBOARD.CARD.TEXT-2" | translate }}
        </p>
        <div class="dashboard-card-section">
          <p>{{ "DASHBOARD.CARD.LINK-TRAININGS-LABEL" | translate }}</p>
          <dx-button
            [text]="'DASHBOARD.CARD.LINK-TRAININGS-BUTTON' | translate"
            type="default"
            stylingMode="contained"
            class="button"
            (click)="openMyTrainings()"
          ></dx-button>
        </div>
        <div class="dashboard-card-section">
          <p>{{ "DASHBOARD.CARD.LINK-CATALOGUE-LABEL" | translate }}</p>
          <dx-button
            [text]="'DASHBOARD.CARD.LINK-CATALOGUE-BUTTON' | translate"
            type="default"
            stylingMode="contained"
            class="button"
            (click)="openTrainingCatalogue()"
          ></dx-button>
        </div>
      </div>
    </div>
  </div>
</app-page>
